import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// ===== Types =====
export interface CmsNews {
  id: number;
  title: string;
  category: string;
  summary: string;
  content: string;
  cover_image: string;
  author: string;
  tags: string[];
  view_count: number;
  is_published: boolean;
  published_at: string;
  slug: string;
  pinned: boolean;
  read_time: string;
  created_at: string;
  updated_at: string;
}

export interface CmsBusiness {
  id: number;
  title: string;
  description: string;
  icon: string;
  slug: string;
  image_url: string;
  hero_bg_url: string;
  detail_intro: string;
  highlights: Array<{ label: string; value: string; unit: string }>;
  features: Array<{ title: string; desc: string; icon: string }>;
  cases_data: Array<{ title: string; desc: string }>;
  sort_order: number;
  is_published: boolean;
  created_at: string;
  updated_at: string;
}

export interface CmsAiProduct {
  id: number;
  name: string;
  subtitle: string;
  description: string;
  icon: string;
  codename: string;
  tag: string;
  image_url: string;
  sort_order: number;
  is_published: boolean;
  created_at: string;
  updated_at: string;
}

export interface CmsCase {
  id: number;
  title: string;
  client: string;
  industry: string;
  summary: string;
  content: string;
  cover_image: string;
  hero_bg: string;
  logo_url: string;
  tags: string[];
  metric_value: string;
  metric_label: string;
  slug: string;
  overview: string;
  project_date: string;
  challenges: Array<{ title: string; desc: string; icon: string }>;
  solutions: Array<{ title: string; desc: string; icon: string }>;
  results: Array<{ label: string; value: string; unit: string; icon: string }>;
  testimonial: { content: string; author: string; position: string };
  sort_order: number;
  is_published: boolean;
  created_at: string;
  updated_at: string;
}

export interface CmsHeroSlide {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  image_url: string;
  align: 'left' | 'center' | 'right';
  small_title: boolean;
  is_published: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface SiteVisit {
  id?: number;
  page_path: string;
  page_title?: string;
  referrer?: string;
  user_agent?: string;
  ip_hash?: string;
  session_id?: string;
  device_type?: string;
  region?: string;
}
